import ResolveTable from "./ResolveTable.component"

export default ResolveTable;